import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import RadioButtonItem from "../../../components/formItems/RadioButtonItem";
import SelectItem from "../../../components/formItems/SelectItem";
import DayOfVisitScheduling from "./DayOfVisitScheduling";
const General = (props) => {
  const {
    control,
    approved,
    loading,
    enabled,
    activeHouseVisit,
    changedValues,
    changedItems,
  } = props;
  const presented = changedItems.includes("care_giver_was_presented")
    ? changedValues["care_giver_was_presented"]
    : activeHouseVisit["care_giver_was_presented"];
  const isWronglyPresented =
    (presented && activeHouseVisit.previous_visit__care_giver_was_presented) ||
    (!presented && !activeHouseVisit.previous_visit__care_giver_was_presented);

  const intl = useIntl();
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.general",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <RadioButtonItem
          name="care_giver_was_presented"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.care_giver_was_presented",
          })}
          disabled={approved || !enabled}
          trueFalse={true}
          loading={loading}
          color={isWronglyPresented ? "danger" : "primary"}
        />

        <RadioButtonItem
          name={`report__time_mathed_planning`}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.time_mathed_planning",
          })}
          disabled={approved || !enabled}
          trueFalse={true}
          loading={loading}
        />
        <DayOfVisitScheduling
          date={activeHouseVisit.date}
          patientId={activeHouseVisit.patient__id}
        />

        <RadioButtonItem
          name="report__first_visit"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.first_visit",
          })}
          disabled={approved || !enabled}
          trueFalse={true}
          loading={loading}
        />
        <RadioButtonItem
          name="report__phone_visit"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.phone_visit",
          })}
          disabled={approved || !enabled}
          trueFalse={true}
          loading={loading}
        />
        <SelectItem
          name="report__care_giver_absence_reason"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.care_giver_absence_reason",
          })}
          params={{
            name: "meta/system_tables/house_visits/care_giver_absence_reason",
          }}
          disabled={approved || !enabled}
          loading={loading}
        />

        <SelectItem
          name="report__other_participants"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.other_participants",
          })}
          params={{
            name: "meta/system_tables/house_visits/other_participants",
          }}
          disabled={approved || !enabled}
          loading={loading}
        />
      </IonCardContent>
    </IonCard>
  );
};

export default General;
